/**
 * Rol del usuario en el cliente — para DECIDIR QUÉ SE PINTA, nunca para
 * autorizar. Quien autoriza es el backend (`auth/dependencies.py`); esto solo
 * evita enseñar en pantalla lo que el servidor ya recorta.
 *
 * La escala está alineada a `ROLE_LEVEL` de `backend/auth/dependencies.py:351`:
 *   user 1 · viewer 2 · analyst 3 · ejecutor 4 · admin 5 · superadmin 6
 *
 * OJO: `ROLE_RANK` en `components/ProtectedRoute.js:35` es OTRA tabla y le
 * falta `ejecutor`, así que ahí un `ejecutor` sale como rango desconocido.
 * No se unifica desde aquí porque eso toca el control de acceso de todas las
 * rutas; está reportado aparte.
 */
export const ROLE_LEVEL = {
  user: 1,
  viewer: 2,
  analyst: 3,
  ejecutor: 4,
  admin: 5,
  superadmin: 6,
};

/** Rol del JWT guardado, o null si no hay token legible. */
export function getCurrentRole() {
  try {
    const token = localStorage.getItem('access_token');
    if (!token || token.split('.').length !== 3) return null;
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload?.role ?? null;
  } catch {
    // Token ilegible: se trata como "rol desconocido", no como privilegiado.
    return null;
  }
}

/**
 * ¿El rol actual llega al mínimo pedido?
 * Rol desconocido → `false`: ante la duda, se enseña MENOS, no más.
 */
export function hasMinRole(minRole) {
  const min = ROLE_LEVEL[minRole];
  if (!min) return false;
  const level = ROLE_LEVEL[getCurrentRole()] ?? 0;
  return level >= min;
}

/** Atajo para el caso habitual: ¿puede ver detalle de infraestructura? */
export const isSocReader = () => hasMinRole('viewer');
